import React from "react";

import { AVAILABLE_LANGS } from "@typings/globals";
import { ANCHOR_IDS } from "@typings/anchorIds";

import { Container } from "@components/Layout/Container";
import { CSSGrid } from "@components/Layout/CssGrid";

import * as Styled from "./Hero.styled";
import { selectorAreas, titleAreas } from "./Hero.grids";
import { Image } from "./Image";

interface Props {
  language: AVAILABLE_LANGS;
}

export const Hero: React.FC<Props> = props => {
  return (
    <Styled.Root id={ANCHOR_IDS.BOOK_CLEANING}>
      <Container>
        <CSSGrid areas={titleAreas} />
      </Container>

      <Container>
        <CSSGrid
          areas={selectorAreas}
          areasProps={{ Selector: { language: props.language } }}
        />
      </Container>

      <Styled.IconContainer>
        <Styled.BoltIcon
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 305 229"
          fill="currentColor"
        >
          <path d="M165.525 89.4446L305 0L149.392 200.485L143.274 130.845L27.636 229L0 130.845L165.525 36.289V89.4446Z" />
        </Styled.BoltIcon>
      </Styled.IconContainer>

      <Image />
    </Styled.Root>
  );
};
